import { jsxs as _jsxs } from "react/jsx-runtime";
const AlertMessage = ({ type, message }) => {
    const icon = type === "success" ? "✓ " : "✕ ";
    const baseClasses = "p-4 rounded-lg mb-5 text-sm font-medium border";
    const typeClasses = type === "success"
        ? "bg-green-20 text-green-90 border-green-30"
        : "bg-red-20 text-red-90 border-red-30";
    return (_jsxs("div", { className: `${baseClasses} ${typeClasses}`, children: [icon, message] }));
};
export default AlertMessage;
